// Centred success panel (the "Thank You!" surface after submits).
// Plan 24: replaces three near-identical implementations spread across
// contact, testimonials, and booking flows.

import type { HTMLAttributes, ReactNode } from 'react';
import { CheckCircle2 } from '../icons';
import { cn } from '../utils/cn';
import { Heading } from './Heading';

export interface SuccessCardProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  title: ReactNode;
  message?: ReactNode;
  /** Optional call-to-action rendered below the copy (usually a `<Button>`). */
  cta?: ReactNode;
}

export const SuccessCard = ({ title, message, cta, className, ...rest }: SuccessCardProps) => (
  <div
    role="status"
    aria-live="polite"
    className={cn(
      'bg-white p-10 md:p-12 rounded-[2.5rem] border border-stone-200 shadow-xl text-center max-w-2xl mx-auto space-y-6',
      className
    )}
    {...rest}
  >
    <div className="w-20 h-20 bg-green-50 rounded-full flex items-center justify-center mx-auto">
      <CheckCircle2 className="w-10 h-10 text-green-500" aria-hidden="true" />
    </div>
    <Heading level={3}>{title}</Heading>
    {message && <div className="text-stone-600 leading-relaxed text-base">{message}</div>}
    {cta && <div className="pt-2">{cta}</div>}
  </div>
);
